export type CTraderSocketParameters = {
    host: string;
    port: number;
};
